export default "__VITE_ASSET__BcOs7kaE__$_?no-inline__"